<template>
  <section class="bloc-text-cta">
    <div class="bloc-text-cta__wrapper">
      <p class="bloc-text-cta__text">{{ content.text }}</p>
      <router-link v-if="!content.cta.external" :to="content.cta.link" class="bloc-text-cta__link">{{ content.cta.title }}</router-link>
      <a v-else :href="content.cta.link" target='_blank' class="bloc-text-cta__link">{{ content.cta.title }}</a>
    </div>
  </section>
</template>

<script>
export default {
  name: 'TextCta',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-text-cta {
    width: 100vw;
    background: $th-grey-light;
    padding: rem(45) 0 rem(40);

    @include media($from: small) {
      padding: rem(75) 0 rem(60);
    }

    &__wrapper {
      width: grid_m(5, 4);
      margin: 0 auto;

      @include media($from: small) {
        width: 100%;
      }
    }

    &__text {
      @include paragraph($type: 'normal-gotham', $color: $th-cherry, $uppercase: true);
      position: relative;
      text-align: center;
      display: block;

      @include media($from: small) {
        width: grid(7, 6);
        margin: 0 auto;
      }
    }

    &__link {
      @include paragraph($type: 'small-2-gotham', $color: $th-white, $uppercase: true);
      display: block;
      width: max-content;
      margin: 0 auto;
      font-weight: 600;
      margin-top: rem(28);
      padding: rem(13) rem(32);
      background: $th-gold;
    }
  }
</style>
